import React, {Component} from 'react';

import Tabs from './tabs/Tabs';

import withStickyBehavior from './withStickyBehavior';

import './StickyTabs.scss';

const NABVAR_HEIGHT = 72;


class StickyTabs extends Component {
    render() {
        const {items, onTabChange} = this.props;

        return (
            <Tabs
                items={items}
                onTabChange={onTabChange}
            />
        );
    }
}

export default withStickyBehavior(StickyTabs, {topAdjust: NABVAR_HEIGHT});